// extracted by mini-css-extract-plugin
export default {"root":"DownloadModal_root__e0XMO","tip":"DownloadModal_tip__MPLuR","tools":"DownloadModal_tools__btA-i"};